import { Container } from "react-bootstrap";
import { Toaster } from "sonner";

const AuthenticationLayout = ({ children }) => {
  return (
    <Container fluid className="auth-page-content py-3 overflow-hidden">
      {children}
      <Toaster />
    </Container>
  );
};

export default AuthenticationLayout;
